var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitelinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linked_in",
    transform: "translate(-15506 -8789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7a0d5c79568034624e7a2092b2d5daf4",
    "data-name": "7a0d5c79568034624e7a2092b2d5daf4",
    transform: "translate(15507.421 8790.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M18.381.656A1.972,1.972,0,0,1,20.35,2.626V18.381a1.972,1.972,0,0,1-1.969,1.969H2.626A1.972,1.972,0,0,1,.656,18.381V2.626A1.972,1.972,0,0,1,2.626.656H18.381m0-.656H2.626A2.634,2.634,0,0,0,0,2.626V18.381a2.634,2.634,0,0,0,2.626,2.626H18.381a2.634,2.634,0,0,0,2.626-2.626V2.626A2.634,2.634,0,0,0,18.381,0Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17643",
    "data-name": "Path 17643",
    d: "M18.6,18.471V14.442c0-2.158-1.152-3.163-2.689-3.163a2.316,2.316,0,0,0-2.1,1.161v-1H11.468c.031.66,0,7.027,0,7.027H13.8V14.547a1.6,1.6,0,0,1,.077-.569,1.278,1.278,0,0,1,1.2-.854c.846,0,1.184.644,1.184,1.589v3.759Zm-9.59-7.986a1.218,1.218,0,1,0,.015-2.428,1.217,1.217,0,1,0-.03,2.428Zm1.168,7.986V11.444H7.84v7.027Z",
    transform: "translate(-2.646 -2.768)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16304",
    "data-name": "Rectangle 16304",
    width: 24,
    height: 24,
    transform: "translate(15506 8789)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelinkedin);
export default __webpack_public_path__ + "static/media/whitelinkedin.6d66fda7746849c3ecef0e6b2190056c.svg";
export { ForwardRef as ReactComponent };